<template>
    <div id="coll">
        <Breadcrumb></Breadcrumb>
        <div class="form-body">
            <el-form  :model="queryParams" label-width="80px" style="padding: 0 5px" ref="queryParams">
                <el-form-item label="店铺名称">
                    <el-radio-group v-model="queryParams.shopId" class="hide_input" @change="clickShopName">
                        <el-radio label="all">全部</el-radio>
                        <el-radio v-for="(item,index) in dpList" :label="item.shopId">{{item.shopName}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div style="border-top: 2px dashed #afafaf;padding-top: 5px;">
                    <el-form-item label="搜索类型">
                        <el-radio-group v-model="queryParams.searchType" size="small" class="hide_input">
                            <el-radio :label="1">标题</el-radio>
                            <el-radio :label="2">SKU</el-radio>
                            <el-radio :label="3">Parent SKU</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="搜索内容">
                        <el-input size="small" v-model="queryParams.searchStr" style="width: 30%;border: 0px;" placeholder="请输入内容"></el-input>
                        <el-button size="small" type="primary" @click="search" style="margin-left: 10px">搜索</el-button>
                        <el-button size="small" type="text" style="margin-left: 10px" @click="srarchView">高级搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <!--高级搜索,点击才显示-->
        <div v-show="advancedSearchDiaLog" style="background-color:white;padding-bottom: 10px;width: 100%">
            <div class="search">
                <el-form  :model="queryParams" label-width="80px" ref="levelQueryParams" class="demo-form-inline">
                    <el-form-item label="价格">
                        <el-col :span="11">
                            <el-form-item prop="priceStart">
                                <el-input
                                        onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"
                                        v-model="queryParams.priceStart"
                                        placeholder="请输入内容"
                                        size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col style="text-align: center;" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-form-item prop="priceEnd">
                                <el-input
                                        onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"
                                        v-model="queryParams.priceEnd"
                                        placeholder="请输入内容"
                                        size="small"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="库存">
                        <el-col :span="11">
                            <el-form-item prop="inventStart">
                                <el-input
                                        onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{2,}/g,'');"
                                        v-model="queryParams.inventStart"
                                        placeholder="请输入内容"
                                        size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col style="text-align: center;" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-form-item prop="inventEnd">
                                <el-input
                                        onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{2,}/g,'').match(/^\d{11,}/g);"
                                        v-model="queryParams.inventEnd"
                                        placeholder="请输入内容"
                                        size="small"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="站点" prop="site">
                        <el-select clearable  v-model="queryParams.site" placeholder="请选择活动区域" size="small">
                            <el-option label="中国" value="shanghai"></el-option>
                            <el-option label="美国" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品分类" prop="productCf">
                        <el-select clearable  v-model="queryParams.productCf" placeholder="请选择活动区域" size="small">
                            <el-option label="中国" value="shanghai"></el-option>
                            <el-option label="美国" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发货期" prop="deliveryTimeStart">
                        <el-date-picker
                                v-model="queryParams.deliveryTimeStart"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" size="small">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="text-align: right">
                        <el-button type="text" size="small" @click="cancel">取消</el-button>
                        <el-button type="text" @click="reset" size="small">重置</el-button>
                        <el-button type="primary" @click="search" size="small">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <!--按钮-->
        <div style="padding-bottom: 10px;display: inline-block;width: 100%;">
            <div style="float: left">
                <el-dropdown trigger="click" @command="batchHandle">
                    <el-button type="primary" size="small">批量操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">批量复制为新产品</el-dropdown-item>
                        <el-dropdown-item command="2">批量下架产品</el-dropdown-item>
                        <el-dropdown-item command="3">批量删除</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown placement="bottom-start" trigger="click" ref="xxx">
                    <el-button size="small" type="primary" style="margin-left: 10px">移动分类<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <div class="scro">
                            <el-scrollbar style="height: 200px">
                                <el-tree style="text-align: center;margin-right: 15px" :data="ydlfTree.treeData" :props="ydlfTree.treeDefaultProps"
                                         @node-click="handleNodeClick" :default-expand-all="true" :expand-on-click-node="false"></el-tree>
                            </el-scrollbar>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div style="float: right">

            </div>
        </div>
        <div id="pane" style="margin-bottom: -3px">
            <!--<el-button>在线({{stateSize.onLine}})</el-button>-->
            <!--<el-button>已售完({{stateSize.soldOut}})</el-button>-->
            <!--<el-button>已禁卖({{stateSize.prohibitedSell}})</el-button>-->
            <!--<el-button>未上架({{stateSize.notOnTheShelf}})</el-button>-->
            <!--<el-button>疑似删除({{stateSize.suspectedDelete}})</el-button>-->
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="background-color: white;width: 504px;margin-bottom: -15px;">
                <el-tab-pane :label="'在线('+stateSize.onLine+')'" name="05"></el-tab-pane>
                <el-tab-pane :label="'已售完('+stateSize.soldOut+')'" name="09"></el-tab-pane>
                <el-tab-pane :label="'已禁卖('+stateSize.prohibitedSell+')'" name="10"></el-tab-pane>
                <el-tab-pane :label="'未上架('+stateSize.notOnTheShelf+')'" name="11"></el-tab-pane>
                <el-tab-pane :label="'疑似删除('+stateSize.suspectedDelete+')'" name="07"></el-tab-pane>
            </el-tabs>
        </div>
        <div>
            <el-table id="outTable" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                      :span-method="arraySpanMethod"  @selection-change="handleSelectionChange" :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="mainPic" label="图片" width="95" align="center">
                    <template scope="scope">
                        <div>
                            <div class="imgInDiv">
                                <div class="borderDiv">
                                    <img class="imgCls" :src="scope.row.mainPic"/>
                                    <div class="pz_o">
                                        <div class="pz_po">
                                            <div class="pz_at">
                                                <a>添加来源</a>
                                            </div>
                                            <div class="pz_img_o" style="width: 300px;height: 300px;">
                                                <img class="outImg" :src="scope.row.mainPic">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ly">
                                <a>1688</a>
                            </div>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column prop="proTitle" label="标题/产品ID" width="300">
                    <template slot-scope="scope">
                        <el-row style="text-align: center">{{scope.row.proTitle}}</el-row>
                        <div style="padding-left: 20px;margin-top: 20px">
                            <el-row style="color: #8a8a8a">店铺[{{scope.row.shopName}}]</el-row>
                            <el-row>备注:{{scope.row.remark}}</el-row>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="htmlCode"  label="SKU" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.htmlCode"></div>
                    </template>
                </el-table-column>
                <el-table-column label="价格" align="center"></el-table-column>
                <el-table-column label="促销价" align="center"></el-table-column>
                <el-table-column label="库存" align="center"></el-table-column>
                <el-table-column prop="createTime" label="时间" align="center" width="200">
                    <template slot-scope="scope">
                        <el-row>创建:</el-row>
                        <el-row>{{scope.row.createTime}}</el-row>
                        <el-row>更新:</el-row>
                        <el-row>{{scope.row.updateTime}}</el-row>
                    </template>
                </el-table-column>
                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <!--<el-button  type="text" size="mini" @click="move(scope.row)">移入待发布</el-button><br/>-->
                        <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button><br/>
                        <!--<el-dropdown @command="nowOrTimeRelease">-->
                            <!--<span class="el-dropdown-link">-->
                                 <!--<el-link type="primary" style="font-size: 12px">发布</el-link>-->
                            <!--</span>-->
                            <!--<el-dropdown-menu slot="dropdown">-->
                                <!--<el-dropdown-item :command="beforeHandleCommand(scope.row.pId,0)">立即发布</el-dropdown-item>-->
                                <!--<el-dropdown-item :command="beforeHandleCommand(scope.row.pId,1)">定时发布</el-dropdown-item>-->
                            <!--</el-dropdown-menu>-->
                        <!--</el-dropdown>-->
                        <!--<br>-->
                        <el-button  type="text" size="mini" @click="lowerShelfProduct(scope.row.pId)">下架产品</el-button><br/>
                        <el-button  type="text" size="mini" @click="addRemark(scope.row)">添加备注</el-button><br/>
                        <el-button  type="text" size="mini" @click="deleteRow(scope.row)">删除</el-button><br/>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="queryParams.pageNum"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList"
            />
        </div>
        <!--添加备注-->
        <el-dialog :close-on-click-modal="false"   title="添加备注" width="35%" :visible.sync="noteDialogVisible" class="note-dialog"  @close="resetValue">
            <el-row style="display: flex;align-items: center">
                <el-col :span="2">
                    <p>内容:</p>
                </el-col>
                <el-col :span="22">
                    <el-input v-model="form.remark"  placeholder="请输入介绍信息" type="textarea" :rows="10">

                    </el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetValue" size="small">取 消</el-button>
                <el-button type="primary" @click="submitRemark(form.remark)" size="small">确 定</el-button>
            </div>
        </el-dialog>
        <!--定时发布-->
        <el-dialog :close-on-click-modal="false"   title="定时发布" width="35%" :visible.sync="timedReleaseDig" class="note-dialog"   @close="resetValue">
            <el-row style="display: flex;align-items: center">
                <el-col :span="5">
                    <p>定时发布时间:</p>
                </el-col>
                <el-col :span="16">
                    <el-date-picker
                            v-model="timedReleaseValue"
                            type="datetime"
                            placeholder="选择日期时间"
                            :picker-options="pickerOptions"
                            format="yyyy-MM-dd"
                            value-format="timestamp">
                    </el-date-picker>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetValue" size="small">取 消</el-button>
                <el-button type="primary" @click="submitTimedRelease(timedReleasePId)" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {loadData,updateShopee,batchdeleteShopee,singledeleteShopee,
        batchUpdateByID,updateShopeeRemark,batchIntervalPublishItem,getProductStateList,lowerShelfProduct} from '@/api/product/shopee/shopee'
    import ElRow from "element-ui/packages/row/src/row";
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getShopByPlatCode} from '@/api/product/common';
    import {getTree} from '@/api/tree/tree';
    export default {
        components: {ElRow,Breadcrumb},
        name: "CollectionBox",
        data() {
            return {
                //禁止选择之前时间
                pickerOptions: {
                    disabledDate(time) {
                         return time.getTime() < Date.now() - 3600 * 1000 * 24;
                    }
                },
                // 总条数
                total: 0,
                // 查询参数
                queryParams:{
                    pageNum: 1,
                    pageSize: 10,
                    dataSource:'',//数据来源
                    pubStatus:'05',  //商品状态 02是待发布
                    searchStr: null, //搜索内容
                    searchType: 1,//搜索类型
                    shopId:'all', //店铺
                    //高级搜索
                    priceStart:null,//价格开始
                    priceEnd:null,//价格结束
                    inventStart:null,//库存开始
                    inventEnd:null,//库存结束
                    site:null,//站点
                    productCf:null,//产品分类
                    deliveryTimeStart:null,//发货期开始
                    deliveryTimeEnd:null,//发货期结束
                },
                currentPage: 1,
                form: {
                    pId:null,
                    remark:'',
                },
                dpList: [],
                tableData: [],
                spanArr: [],
                innerTableData:[],
                innerData: [],
                ydlfTree:{
                    treeData: [],
                    treeDefaultProps: {
                        children: 'children',
                        label: 'label',
                        value:'value',
                        pCatId:'pCatId'
                    },
                },
                noteDialogVisible:false,//备注弹框
                advancedSearchDiaLog:false,  //高级搜索弹框
                ids:[], //选中的ID
                shopeeList:[], //批量对象,
                timedReleaseDig:false, //定时发布展示框
                timedReleaseValue:null, //定时发布时间值
                timedReleasePId:null, //定时发布的PID
                isBatch:null,//区分是单个还是批量定时发布 0:单个,1:批量
                //产品的状态
                stateSize:{
                    onLine:0, //在线
                    soldOut:0, //已售完
                    prohibitedSell:0, //已禁卖
                    notOnTheShelf:0,  //未上架
                    suspectedDelete:0, //疑似删除
                    lowerShelf:0 //已下架
                },
                activeName:'05',
            }
        },
        computed:{
            treeId(){
                return this.$route.query.treeId;
            },
        },
        watch:{
            treeId(){
                this.getList()
            },
        },
        created() {
            var that = this
            that.getList();
            that.getPlatList(that);
            that.getMoveClassification(that);
            that.getProductStateList();
        },
        methods: {
            getList(){
                console.log(this.treeId);
                //树的ID
                this.queryParams['typeNo']=this.treeId
                //当前登录的人
                this.queryParams['operNo']=this.$store.state.user.name
                loadData(this.queryParams).then((res) => {
                    this.tableData = res.rows;
                    this.total = res.total;
                    for (let key in this.tableData) {
                        //SKU集合赋值
                        let innerData = this.tableData[key].sShopeeSkuList;
                        this.innerData= innerData;
                        this.Generationhtml(key);
                    }
                })
            },
            //添加备注方法
            addRemark(row){
                for (let key in this.form) {
                    this.form[key]=null;
                }
                this.noteDialogVisible=true;
                this.form.remark=row.remark;
                this.form.pId=row.pId;
            },
            //提交备注
            submitRemark(remark){
                updateShopeeRemark(this.form).then((res) => {
                    if (res.code === 200) {
                        this.msgSuccess("修改成功");
                        this.getList();
                        this.noteDialogVisible = false;
                    }
                })
            },
            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            show: function() {

            },
            search: function() {
                this.getList()
            },
            //批量操作
            batchHandle: function(val) {
                if ("1" == val) {
                    this.msgSuccess("尚在开发");
                } else if(val == 2) {
                    this.batchLowerShelfProduct();
                }else{
                    this.batchDelete();
                }
            },
            //批量移入待发布
            batchUpdate() {
                const shopeeList = this.shopeeList;
                if (this.shopeeList.length==0){
                    this.msgError("批量待发布至少选择一条数据");
                    return
                }
                this.$confirm('是否确认把这' + this.shopeeList.length + '条数据项批量移入待发布', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    shopeeList.forEach((item) => {
                        //往对象添加新字段
                        item['pubStatus']='02'
                    });
                    return batchUpdateByID(JSON.stringify(shopeeList));
                }).then(() => {
                    this.getList();
                    this.msgSuccess("修改成功");
                }).catch(function() {});
            },
            //批量删除
            batchDelete() {
                const ids =this.ids;
                if (this.ids.length == 0){
                    this.msgError("请选择要删除的产品");
                    return;
                }
                this.$confirm('是否确认删除选择的' + this.ids.length + '条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchdeleteShopee(ids);
                }).then(() => {
                    this.getProductStateList();
                    this.getList();
                    this.msgSuccess("删除成功");
                }).catch(function() {});
            },
            //用户勾选
            handleSelectionChange(val) {
                this.ids=[];
                this.shopeeList=[];
                //获取当前用户
                var userName = this.$store.state.user.name;
                val.forEach((item) => {
                    //批量移入待发布
                    var updateStatePara={
                        "pId":item.pId,
                        "operNo":userName,
                    };
                    this.ids.push(item.pId);
                    this.shopeeList.push(updateStatePara);

                });
            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 3) {
                    return [1, 4];
                }else if(columnIndex === 4 || columnIndex === 5 ||columnIndex === 6){
                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
                    return [0, 0];
                }
            },
            getSpanArr(data) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                        if (data[i]["id"] === data[i - 1]["id"]) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            move(row) {
                this.$confirm('确定要 [移入到待发布吗]?', "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return updateShopee(row.pId);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("移入待发布成功");
                }).catch(function() {});
            },
            edit(row) {
                //编辑产品
                this.$router.push({path:"/product/shopee/onLineEdit",query:{pId:row.pId}})
            },
            addNote: function() {

            },
            deleteRow(row) {
                let pId = row.proTitle;
                this.$confirm('是否确认删除shopee产品标题为<span style="color: red">'+pId+'</span>的数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    //显示HTML
                    dangerouslyUseHTMLString: true,
                    type: "warning"
                }).then(function() {
                    return singledeleteShopee(row.pId);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("删除成功");
                }).catch(function() {});
            },
            //点击移入分类的tree
            handleNodeClick(val) {
                if (this.ids.length == 0){
                    this.msgError("请选择需要移动分类的商品");
                    //点击后消失,防止多次点击
                    this.$refs.xxx.visible =false
                    return
                }
                let shopeeList = this.shopeeList;
                this.$confirm('是否确认把这' + this.ids.length + '条数据项批量移入分类--><span style="color: red">'+val.label+'</span>吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    //显示HTML
                    dangerouslyUseHTMLString: true,
                    type: "warning"
                }).then(function() {
                    shopeeList.forEach((item) => {
                        //往对象添加新字段
                        item['typeNo']=val.value
                    });
                    return batchUpdateByID(JSON.stringify(shopeeList));
                }).then(() => {
                    this.getList();
                    this.msgSuccess("修改成功");
                }).catch(function() {});
                //点击后消失,防止多次点击
                this.$refs.xxx.visible =false
            },
            //生成表格HTML
            Generationhtml(key){
                // 控制单独的class
                var className = key;
                var tabHtml ='<table class="innerTab" style="width: 100%">'
                this.innerData.forEach((item,index)=>{
                    //转空字符
                    if (item.skuno==null){
                        item.skuno='';
                    }
                    if (item.price==null){
                        item.price='';
                    }
                    if (item.promPrice==null){
                        item.promPrice='';
                    }
                    if (item.invent==null){
                        item.invent='';
                    }
                    if(index < 5){
                        tabHtml += `<tr>
					<td >`+item.skuno +`</td>
					<td >`+item.price +`</td>
					<td >`+item.promPrice +`</td>
					<td >`+item.invent +`</td>

				</tr>`;
                    }else{
                        tabHtml += `<tr  style="display: none" class=${className}>
					<td >`+item.skuno +`</td>
					<td >`+item.price +`</td>
					<td >`+item.promPrice +`</td>
					<td >`+item.invent +`</td>
				</tr>`;
                    }

                });
                if(this.innerData.length > 5){
                    tabHtml += `</table><el-row class="tab_butt"><div id="row_bt" onclick="explanRow(${className})">展开<i class="el-icon-caret-bottom"></i></div></el-row>`;
                }else{
                    tabHtml += `</table>`;
                }
                this.tableData[key].htmlCode = tabHtml;
                window.explanRow = function (val) {
                    var flag = $("."+val).is(":hidden");
                    if(flag){
                        $("#row_bt").html(`收起<i class="el-icon-caret-top"></i>`);
                        $("."+val).show();
                    }else{
                        $("#row_bt").html(`展开<i class="el-icon-caret-bottom"></i>`);
                        $("."+val).hide();
                    }
                }
            },
            //获取店铺集合
            getPlatList(that){
                //获取当前用户
                var userName = this.$store.state.user.name;
                // var params={
                //     "userAccount":userName,
                //     "platNo":'05',
                // };
                var params='05';
                //获取店铺集合
                getShopByPlatCode(params).then((res) => {
                    that.dpList=res.data
                })
            },
            //移动分类树形数据
            getMoveClassification(that){
                getTree().then((res) => {
                    this.ydlfTree.treeData=res.data;
                })
            },
            //控制高级搜索的显示隐藏
            srarchView(){
                if (this.advancedSearchDiaLog==true){
                    this.advancedSearchDiaLog=false;
                }else{
                    this.advancedSearchDiaLog=true;
                }
            },
            //重置
            reset(){
                //清空表单
                this.$refs.levelQueryParams.resetFields();
            },
            //取消
            cancel(){
                //清空表单
                this.$refs.levelQueryParams.resetFields();
                this.advancedSearchDiaLog=false
            },
            //店铺查询
            clickShopName(val){
                this.$refs.levelQueryParams.resetFields()
                this.queryParams.searchStr=null
                this.getList();
            },
            //发布的下拉菜单
            nowOrTimeRelease(val){
                //0:立即发布,1:定时发布
                if (val.type ==0){
                    this.msgSuccess("仍在开发中,请耐心等待");
                }else{
                    this.dropdownTimedRelease(val.pId);
                }
            },
            //command处理前的数据
            beforeHandleCommand(pId,type){
                return {
                    'pId': pId,
                    'type': type,
                }
            },
            //点击定时发布
            dropdownTimedRelease(pId){
                this.timedReleaseDig=true;
                this.timedReleasePId=pId;
                this.isBatch=0;
            },
            //提交定时发布
            submitTimedRelease(timedReleasePId){
                var timedReleaseValue = this.timedReleaseValue;
                if (timedReleaseValue!=null){
                    //1.获取当前时间
                    var nowDate = new Date()
                    //2. 获取当前分钟
                    var min=nowDate.getMinutes();
                    //3. 设置dao当前时间+5分钟：把当前分钟数权+5后的值重新设置为date对象的分钟数
                    nowDate.setMinutes(min+5);
                    //加5分钟之后的时间戳
                    var time = nowDate.getTime();
                    if(timedReleaseValue < time) {
                        this.msgError("定时发布的时间最小要大于当前时间5分钟");
                        return ;
                    }
                    var batch = this.isBatch;
                    var data;
                    //区分批量还是单个
                    if(batch==0){
                        data = this.handleTimedReleaseValue(timedReleaseValue,timedReleasePId);
                    }else{
                        var ids = this.ids;
                        var join = ids.join("-");
                        data = this.handleTimedReleaseValue(timedReleaseValue,join);
                    }
                    batchIntervalPublishItem(data).then((res) => {
                        this.getList();
                        this.msgSuccess("定时发布设置完成");
                    });
                    this.resetValue();
                }else{
                    this.msgError("时间不能为空");
                    return
                }
            },
            //批量定时发布
            batchSubmitTimedRelease(){
                if (this.ids.length <=0 ){
                    this.msgError("请选择要定时发布的数据");
                    return
                }
                this.timedReleaseDig=true;
                this.isBatch=1;
            },
            //点击取消或者x图标,重置值
            resetValue(){
                //定时发布
                this.timedReleaseDig=false;
                this.timedReleaseValue=null;
                this.timedReleasePId=null;
                //备注
                this.noteDialogVisible = false;
                this.form.remark=null;
            },
            //处理定时发布的值
            handleTimedReleaseValue(timedReleaseValue,pIds){
                var data = {
                    'pIds':pIds,
                    'cron':timedReleaseValue
                }
                return data;
            },
            //点击TAB标签触发
            handleClick(tab, event) {
                this.queryParams.pubStatus = tab.name;
                this.getList();
            },
            //获取商品的各种状态数量
            getProductStateList(){
                getProductStateList().then((res) => {
                    this.stateSize.onLine=res.data.onLine;
                    this.stateSize.soldOut=res.data.soldOut;
                    this.stateSize.prohibitedSell=res.data.prohibitedSell;
                    this.stateSize.notOnTheShelf=res.data.notOnTheShelf;
                    this.stateSize.suspectedDelete=res.data.suspectedDelete;
                });
            },
            //下架产品
            lowerShelfProduct(pId){
                this.$confirm('是否确认把此产品下架?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return lowerShelfProduct(pId);
                }).then(() => {
                    this.getProductStateList();
                    this.getList();
                    this.msgSuccess("下架产品成功");
                }).catch(function() {});
            },
            //批量下架产品
            batchLowerShelfProduct(){
                var length = this.ids.length;
                var join = this.ids.join("-");
                if (length <=0){
                    this.msgError("请选择需要下架的产品");
                    return;
                }
                this.$confirm('是否确认把这'+length+'条产品下架?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return lowerShelfProduct(join);
                }).then(() => {
                    this.getProductStateList();
                    this.getList();
                    this.msgSuccess("下架产品成功");
                }).catch(function() {});
            }
        },
        mounted() {
            this.getSpanArr(this.tableData);
        },
    }
</script>

<style scoped>
    @import '../../../assets/css/Shopee.css';
    /* >>> 是深度选择器,不会影响全局*/
    .scro >>> .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .search{
        background-color: #F5F5F5;
        width: 450px;
        height: 360px;
        margin-left: 80px;
        padding-right: 15px;
        padding-top: 15px;
    }
</style>
